import { render, staticRenderFns } from "./total-spend-vendor-region.vue?vue&type=template&id=3edd779d&scoped=true&"
import script from "./total-spend-vendor-region.vue?vue&type=script&lang=js&"
export * from "./total-spend-vendor-region.vue?vue&type=script&lang=js&"
import style0 from "./total-spend-vendor-region.vue?vue&type=style&index=0&id=3edd779d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd779d",
  null
  
)

export default component.exports